import React, { useState } from 'react';
import MainButton from '@ui-kit/components/mainButton';
import { IAuthService } from '@base/features/auth/model/interfaces';
import { container } from 'tsyringe';
import { ILocalStorage } from '../../storage/interfaces';
import { ResponseCode, StorageKeys } from '../../../utils/constants';
import { Loader } from '@ui-kit/components/loader';

export const GuestEntrance = () => {
  const localStorage: ILocalStorage = container.resolve('localStorage');
  const authService: IAuthService = container.resolve('authService');
  const authData = localStorage.get(StorageKeys.SESSION);
  const [isLoading, setLoading] = useState(false);
  function handleLoginGuest() {
    setLoading(true);
    const authData = localStorage.get(StorageKeys.SESSION);
    const { guestUser, guestToken } = authData || '';
    let uuid = guestUser;
    let firebaseToken = guestToken;

    if (!guestUser && !guestToken) {
      //если новый - регистрируем
      authService
        .doLoginGuest()
        .then((response) => {
          if (response && response.user) {
            uuid = response.user.uid;
            firebaseToken = response.user.refreshToken;

            localStorage.update(StorageKeys.SESSION, { guestUser: uuid });
            localStorage.update(StorageKeys.SESSION, { guestToken: firebaseToken });

            //и сразу входим гостевым
            authService
              .authorizationGuestPlayer(uuid, firebaseToken)
              .then((res) => {
                if (res.code === ResponseCode.SUCCESS) {
                  authService.doEntryDefault(res);
                } else {
                  //Todo обработать коды+модалка
                  alert(`чтото пошло не так ${res}`);
                }
              })
              .catch((err) => {
                alert(`чтото пошло не так ${err}`);
              });
          }
        })
        .catch((err: any) => {
          setLoading(false);
          const errorCode = err.code;
          //const errorMessage = error.message;
          // ...коды для обработки ошибок (вынести потом их:
          if (errorCode === 'auth/operation-not-allowed') {
            alert('You must enable Anonymous auth in the Firebase Console.');
          } else {
            console.error(err);
          }
        });

      //а если уже есть пользователь - входим им
    } else {
      authService
        .authorizationGuestPlayer(uuid, firebaseToken)
        .then((res) => {
          if (res.code === ResponseCode.SUCCESS) {
            authService.doEntryDefault(res);
          } else {
            setLoading(false);
            //Todo обработать коды+модалка
          }
        })
        .catch((err) => {
          setLoading(false);
          alert(`чтото пошло не так ${err}`);
        });
    }
  }

  const loaderJSX = isLoading && <Loader className="loader-container--black" />;

  return authData && authData.isGuestPlayer === 0 ? null : (
    <div className="login-btn-wrap">
      {loaderJSX}
      <MainButton className="login-btn login-btn--opacity" onClick={handleLoginGuest}>
        PLAY AS GUEST
      </MainButton>
    </div>
  );
};
